import React from 'react';
import classnames from 'classnames';

import classes from '../table.module.css';

export default function BodyCol({ data, onClick }) {
  const { isLink, text, newTab, linkUrl, linkTitle, style, isHiddenMobile } = data || {};
  return (
    <td
      style={style}
      className={classnames(classes.data, 'table-data z-pl-20 z-py-14', {
        'd-none d-md-table-cell': isHiddenMobile,
      })}
    >
      {isLink && linkUrl ? (
        <a
          className="list-link"
          target={newTab ? '_blank' : '_self'}
          href={linkUrl}
          title={linkTitle}
          onClick={onClick}
          onContextMenu={onClick} rel="noreferrer"
        >
          {text}
        </a>
      ) : (
        text
      )}
    </td>
  );
}
